import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import Axios from "./../../../../utils/api/axiosConf";
import { url } from "../../../../utils/api/api";
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import LOADING from './../../../../components/loading/loading';
import INPUT from "../../../../components/input/input";
import BUTTON from "../../../../components/buttons/button";
import { color } from "../../../../utils/themes/color";
import recycleImg from "./../../../../assets/images/recycleBin.jpg";




export default function PaymentMethod(props) {
    const userId = props.userId

    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false, 4: false });
    const [methods, setMethods] = useState([]);
    const [newMethod, setNewMethod] = useState(null);
    const [updater, setUpdater] = useState(1);


    useEffect(() => {

        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/payment-method-coch/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 1: false })
                    setMethods(response.data.paymentMethods)
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [updater])

    const submitMethod = () => {
        if (newMethod != null) {
            setLoading({ ...loading, 3: true })
            var x = { "paymentMethods": [] };
            for (const iterator of methods) {
                x.paymentMethods.push(
                    {
                        "title": iterator.title,
                        "number": iterator.number
                    }
                )
            }
            x.paymentMethods.push(
                {
                    "title": newMethod.title,
                    "number": newMethod.number
                }
            )
            Axios.patch(`${url}users/edit-payment-method-coch/${userId}`, x)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setLoading({ ...loading, 3: false })
                        GreenNotif(response.message)
                        setUpdater(updater + 1)
                    }
                    else {
                        RedNotif(response.message)
                        setLoading({ ...loading, 3: false })
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                    setLoading({ ...loading, 3: false })

                });
        } else {
            RedNotif("نام روش و مقدار آن الزامی است")
        }

    }

    const deleteClub = (item) => {

        var x = { "paymentMethods": [] };
        methods.filter(function (obj) {
            if (obj.title !== item.title) {
                x.paymentMethods.push(
                    {
                        "title": obj.title,
                        "number": obj.number
                    }
                )
            }
        });
        Axios.patch(`${url}users/edit-payment-method-coch/${userId}`, x)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 3: false })
                    GreenNotif(response.message)
                    setUpdater(updater + 1)
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 3: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                setLoading({ ...loading, 3: false })

            });
    }



    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                    <Row style={{ marginBottom: '18px' }}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                            <p>افزودن روش پرداخت جدید:</p>
                        </Col>
                    </Row>

                    <Row style={{ marginRight: '8px' }} gutter={20}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                            <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                                <p>مقدار:</p>
                                <p style={{ color: color.mandatoryColor }}>*</p>
                            </div>
                            <INPUT i={(e) => setNewMethod({ ...newMethod, number: e })} />
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                            <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                                <p>نام روش:</p>
                                <p style={{ color: color.mandatoryColor }}>*</p>
                            </div>
                            <INPUT i={(e) => setNewMethod({ ...newMethod, title: e })} />
                        </Col>
                    </Row>

                    <Row gutter={[8, 16]} style={{ marginTop: '32px' }} >
                    {methods.map((itm, idx) =>
                        <Col offset={1} span={6} key={idx} xxl={6} xl={6} lg={6} md={6} sm={6} style={{ border: `1px solid ${color.primary}`, background: "white", height: "120px" }}>

                            <Row style={{ margin: '18px' }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <p style={{ color: color.primary, fontSize: "20px" }}>{itm.title}</p>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '18px' }}>
                                <Col xxl={22} xl={22} lg={22} md={22} sm={22} style={{ marginBottom: '28px' }}>
                                    <p style={{ fontSize: "12px" }}>{itm.number}</p>
                                </Col>
                                <Col xxl={2} xl={2} lg={2} md={2} sm={2} style={{ marginBottom: '28px' }}>
                                    <img src={recycleImg} style={{ width: "50%", cursor: "pointer" }} onClick={() => deleteClub(itm)} />
                                </Col>
                            </Row>

                        </Col>
                    )}

                </Row>
                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON
                            loading={loading[3]}
                            event={(e) => submitMethod()}
                            text={"افزودن روش پرداخت"}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(5)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }


}